import { BaseState } from '@/store/base-state';
import { TableFilterItem, TableOptions } from '@/types';
import { default_lead } from '../services';
import { Leads } from '../types';

export default class LeadsState extends BaseState {
  items: Leads.Item[] = [];
  loading = false;
  filters: Leads.RequestFilters = {
    search: '',
    status: null,
    dates: [],
    region: null,
    categories: null,
    types: null,
  };

  // table filters
  statuses: TableFilterItem[] = [];
  categories: TableFilterItem[] = [];
  regions: string[] = [];
  types: string[] = [];

  reserved_lead_dialog_message = '';
  reserved_lead_dialog_modal = false;

  new_lead_via_socket = {} as Leads.Lead;

  new_lead_via_socket_modal = false;

  current_lead: Leads.Lead = default_lead();
  lead_logs: Leads.LeadLog[] = [];
  is_read_only = false;
  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };

  available_transition_statuses: Leads.AvailableTransitionStatuses[] = [];
}
